<template>
  <b-form @submit.prevent="onSubmit">

    <b-form-group :label="$t('Name')" label-for="name">
      <b-form-input id="name" v-model="planData.name" autofocus :state="errors && ('name' in errors) ? false : null"
        trim autocomplete="off" placeholder="" />
      <b-form-invalid-feedback v-if="errors && ('name' in errors)" :state="errors && ('name' in errors) ? false : null">
        {{ errors.name[0] }}
      </b-form-invalid-feedback>
    </b-form-group>


    <!-- device -->
    <b-form-group :label="$t('Device')" label-for="device" :state="null">



      <v-select v-model="planData.device_id" label="name" :reduce="val => val.device_id"
        :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :options="devicesOptions" :clearable="true"
        input-id="device" @input="set_name($event),refilterAreas()" />



      <b-form-invalid-feedback v-if="errors && ('device_id' in errors)"
        :state="errors && ('device_id' in errors) ? false : null">
        {{ errors.device_id[0] }}
      </b-form-invalid-feedback>
    </b-form-group>





    <!-- Work -->

    <b-form-group :label="$t('Work Area')" label-for="work-area" :state="null">
      <v-select v-model="planData.work_areas" label="name" multiple :close-on-select="false"
        :reduce="val => val.geofence_id" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
        :options="workAreasOptions" :clearable="false" input-id="work_areas" />
      <b-form-invalid-feedback v-if="errors && ('work_areas' in errors)"
        :state="errors && ('camps' in errors) ? false : null">
        {{ errors.work_areas[0] }}
      </b-form-invalid-feedback>
    </b-form-group>

    <b-row>

      <b-col cols="6">
        <!-- leave camp time -->
        <b-form-group :label="$t('Start work time')" label-for="leave-camp" :state="null">
          <flat-pickr v-model="planData.camp_leave" dateFormat="H:m:s" class="form-control"
                      :class="{ 'is-invalid': errors && ('camp_leave' in errors) }" :config="flatPickerConfig"
                      placeholder="HH:MM:SS" />
          <b-form-invalid-feedback v-if="errors && ('camp_leave' in errors)"
                                   :state="errors && ('camp_leave' in errors) ? false : null">
            {{ errors.camp_leave[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>


      <b-col cols="6">
        <!-- back camp time -->
        <b-form-group :label="$t('End work time')" label-for="back-camp" :state="null">
          <flat-pickr v-model="planData.camp_back" :state="null" class="form-control"
            :class="{ 'is-invalid': errors && ('camp_back' in errors) }" :config="flatPickerConfig"
            placeholder="HH:MM" />
          <b-form-invalid-feedback v-if="errors && ('camp_back' in errors)"
            :state="errors && ('camp_back' in errors) ? false : null">
            {{ errors.camp_back[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>

    </b-row>

    <!-- Form Actions -->
    <div class="d-flex mt-2">
      <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-2" type="submit">
        {{ $t('Save') }}
      </b-button>
    </div>
  </b-form>
</template>

<script>

import {
  BCol, BRow, BFormGroup, BFormInvalidFeedback, BFormRadioGroup, BFormCheckboxGroup,
  BButton, BForm, BFormInput, BFormSelect, BFormSelectOption

} from 'bootstrap-vue'
import AreaFormRepeater from '@/components/form/AreaFormRepeater'
import IrrigationFormRepeater from '@/components/form/IrrigationFormRepeater'
import { onUnmounted, ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import store from '@/store'
import formGetLinkedOptions from '@/views/modules/api/formGetLinkedOptions'

export default {
  name: 'DrainagePlanForm',
  components: {
    IrrigationFormRepeater,
    AreaFormRepeater, BButton, BFormCheckboxGroup,
    flatPickr, vSelect, BForm, BFormInput,
    BCol, BRow, BFormGroup, BFormInvalidFeedback, BFormRadioGroup, BFormSelect, BFormSelectOption
  },
  props: {
    errors: {
      type: Object | undefined,
      required: true
    },
    planData: {
      type: Object,
      required: true
    },


    onSubmit: {
      type: Function,
      required: true
    }
  },
  directives: {
    Ripple,
  },
  setup(props) {

    const user = store.getters['auth/user']
    const device_geofences_ids = ref()

    // Register module
    if (!store.hasModule('formOptions'))
      store.registerModule('formOptions', formGetLinkedOptions)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule('formOptions'))
        store.unregisterModule('formOptions')
    })


    const devicesOptions = ref([])

    const workAreasOptions = ref([])

    const workAreasOptions_org = ref([])





    const daysOptions = [
      { text: 'Saturday', value: 'Saturday' },
      { text: 'Sunday', value: 'Sunday' },
      { text: 'Monday', value: 'Monday' },
      { text: 'Tuesday', value: 'Tuesday' },
      { text: 'Wednesday', value: 'Wednesday' },
      { text: 'Thursday', value: 'Thursday' },
      { text: 'Friday', value: 'Friday' },
    ]

    const flatPickerConfig = {
      enableTime: true,
      noCalendar: true,
      time_24hr: true,
      dateFormat: "H:i:S",

    }





    const setOptions = area => {
      switch (area.category) {
        case 'WORK_AREA': workAreasOptions.value.push(area); break

      }

    }


    const set_name = (e) => {
      const device = devicesOptions.value.find(d => d.device_id === e)
      props.planData.name += ` - ${device.name}`
      props.planData.device_id = device.device_id
    }

    const setOriginalOptions = area => {
      switch (area.category) {
        case 'WORK_AREA': workAreasOptions_org.value.push(area); break
      }
    }

    const refilterAreas = () => {
      let d_id = props.planData.device_id
      device_geofences_ids.value = []
      store.dispatch('formOptions/getItemsLinkedTo', {
        deviceId: d_id,
        type: 'deviceGeofences',
      }).then(res => {
        //display areas that link to selected device
        device_geofences_ids.value = res.data.ids;

        workAreasOptions.value = workAreasOptions_org.value.filter((i) => device_geofences_ids.value.includes(i.geofence_id))
      })


    }


    store.dispatch('formOptions/getLinkedOptions', {
      user: user.id,
      type: 'geofence',
      cols: 'geofence_id,name,category'
    }).then(res => {
      res.data.data.map(a => {
        setOptions(a)
        setOriginalOptions(a)
      }
      )

    }

    ).catch(reason => { })


    store.dispatch('formOptions/getLinkedOptions', {
      user: user.id,
      type: 'device',
      cols: 'device_id,name',
      isSupport:false,
    }).then(res => devicesOptions.value = res.data.data).catch(reason => { })


    return {
      daysOptions,
      flatPickerConfig,



      devicesOptions,

      workAreasOptions,
      device_geofences_ids,
      set_name,
      refilterAreas


    }

  }
}
</script>

<style scoped>

</style>
